import { useState } from "react";
import Navbar from "@/components/navbar";
import HeroSection from "@/components/hero-section";
import BenefitsSection from "@/components/benefits-section";
import Footer from "@/components/footer";
import HomepageLeadModal from "@/components/homepage/HomepageLeadModal";
import { FORM_CONFIGS } from "@/config/forms";

export default function YtV2Page() {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [submittedEmail, setSubmittedEmail] = useState("");

  function handleEmailSubmit(e: React.FormEvent) {
    e.preventDefault();
    const v = email.trim().toLowerCase();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) {
      setEmailError("Enter a valid email address.");
      return;
    }
    setEmailError("");
    setSubmittedEmail(v);
    setModalOpen(true);
  }

  return (
    <>
      <Navbar />
      <main className="min-h-screen bg-black font-fira max-w-2xl mx-auto px-4 py-8 sm:py-16 flex flex-col gap-16">
        <HeroSection />

        <section id="join" className="scroll-mt-28">
          <form
            onSubmit={handleEmailSubmit}
            noValidate
            className="flex flex-col gap-3"
          >
            <label htmlFor="yt-v2-email" className="text-sm text-white/70">
              Enter your email to get started
            </label>
            <div className="flex gap-3">
              <input
                id="yt-v2-email"
                type="email"
                autoComplete="email"
                placeholder="you@email.com"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  if (emailError) setEmailError("");
                }}
                className="flex-1 bg-[#1a1a1a] border border-white/10 rounded-lg px-4 py-3 text-white placeholder:text-white/30 focus:outline-none focus:border-white/40 transition-colors"
                aria-describedby={emailError ? "yt-v2-email-error" : undefined}
                aria-invalid={!!emailError}
              />
              <button
                type="submit"
                className="shrink-0 bg-white text-black font-semibold rounded-lg px-5 py-3 hover:bg-white/90 transition-colors"
              >
                Continue
              </button>
            </div>
            {emailError && (
              <p id="yt-v2-email-error" role="alert" className="text-xs text-red-400">
                {emailError}
              </p>
            )}
          </form>
        </section>

        <BenefitsSection />
        <Footer />
      </main>

      <HomepageLeadModal
        open={modalOpen}
        initialEmail={submittedEmail}
        formConfig={FORM_CONFIGS.ytV2}
        codingPathStep
        onClose={() => setModalOpen(false)}
      />
    </>
  );
}